import styled from "styled-components";

export const Container = styled.div`
	max-width: 1024px;
`;
